//@ts-nocheck
import { Box, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../stores";
import { STEPS } from "../stores/utils";
import PaymentInfo from "../tutor-revamp/PaymentInfo";
import { useClientSteps } from "./utils";

type Props = {
  store: IRootStore;
  agent?: any;
  host?: string;
  isReadOnly?: boolean;
};

function PaymentInformation({ store, isReadOnly }: Props) {
  const { onSubmitSection, getFormWrapperProps } = useClientSteps(
    STEPS.PAYMENT_INFO,
    store,
  );
  const paymentProps = {
    ...getFormWrapperProps(STEPS.PAYMENT_INFO),
    // buttonText: "Save",
    // buttonProps: {
    //     width: "30%",
    //     float: "right",
    //     display: "none"
    // },
    onSubmit: onSubmitSection,
  };

  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[5, 12]}
      mx="auto"
    >
      <VStack justifyContent="stretch" alignItems="stretch" spacing={[6, 8]}>
        <PaymentInfo
          store={store.paymentInfo}
          isReadOnly={isReadOnly}
          supportedCountry={store.supportedCountryData}
          loading={store.loading}
          {...paymentProps}
        />
      </VStack>
    </Box>
  );
}

export default observer(PaymentInformation);
